<script setup lang="ts">
import { useTasksWidget } from '@/composables/useTasksWidget'
import { Button } from '@/components/ui/button'
import { CheckSquare, Maximize2, X } from 'lucide-vue-next'

const { isMinimized, restore, close } = useTasksWidget()
</script>

<template>
  <!-- Minimized state only (FAB is in Navbar) -->
  <Transition
    enter-active-class="transition-all duration-300 ease-out"
    leave-active-class="transition-all duration-200 ease-in"
    enter-from-class="opacity-0 translate-y-4 scale-95"
    enter-to-class="opacity-100 translate-y-0 scale-100"
    leave-from-class="opacity-100 translate-y-0 scale-100"
    leave-to-class="opacity-0 translate-y-4 scale-95"
  >
    <div
      v-if="isMinimized"
      class="fixed bottom-20 right-4 z-[90] bg-background border rounded-lg shadow-lg p-3 flex items-center gap-3 w-56"
    >
      <div class="flex-shrink-0 h-8 w-8 rounded bg-primary/10 flex items-center justify-center">
        <CheckSquare class="h-4 w-4 text-primary" />
      </div>
      <div class="flex-1 min-w-0">
        <p class="text-sm font-medium truncate">Mis Tareas</p>
        <p class="text-xs text-muted-foreground">Minimizado</p>
      </div>
      <div class="flex items-center gap-1 flex-shrink-0">
        <Button variant="ghost" size="icon" class="h-7 w-7" @click="restore" title="Restaurar">
          <Maximize2 class="h-3.5 w-3.5" />
        </Button>
        <Button variant="ghost" size="icon" class="h-7 w-7 text-muted-foreground hover:text-destructive" @click="close" title="Cerrar">
          <X class="h-3.5 w-3.5" />
        </Button>
      </div>
    </div>
  </Transition>
</template>
